import React from "react";

export default function ForCheck() {
  return <div>ForCheck</div>;
}
